import styled from 'styled-components';
import { blue, blueDark01 } from '../../../../../../styles/colors';
import { PrimaryButton } from '../../../../../../styles/common.styles';

export const CriteriaContainer = styled.div`
    width: 100%;
    box-sizing: border-box;
    min-height: 48px;
    padding: 16px 100px;
    background: #d0e3e7;
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const CriteriaHeader = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    height: 20px;
    gap: 12px;

    /* Switcher's circle is absolutely positioned inside a 50px box; shrink the box to the circle so the gap is the visible gap. */
    .switch-mesh {
        width: 24px;

        .switch-container {
            margin-left: 12px;
        }
    }
`;

export const CriteriaToggle = styled.div`
    width: 24px;
    height: 24px;
    margin-right: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: ${blueDark01};
    color: white;
    font-size: 16px;
    line-height: 18px;
    font-weight: 600;
`;

export const CriteriaTitle = styled.div`
    font-family: 'Proxima N W15 Bold';
    font-size: 14px;
    font-weight: 400;
    color: ${blueDark01};
`;

export const EditCriteriaButton = styled(PrimaryButton)`
    display: block;
    margin: 0 0 12px 50px;
    padding: 6px 12px;
    border: none;
    border-radius: 2px;
    background: #258ee8;
    color: white;
    font-size: 14px;
    font-family: 'Proxima N W15 Bold';
    cursor: pointer;
    &:hover {
        background: #197acb;
    }
`;

export const CriteriaGrid = styled.div`
    display: flex;
    align-items: flex-start;
    column-gap: 16px;
    padding-left: 32px;
`;

// Columns are independent so the gap between groups doesn't depend on a taller group in a neighbouring column.
export const CriteriaColumn = styled.div`
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    row-gap: 24px;
`;

export const CriteriaGroup = styled.div`
    min-width: 0;
`;

export const CriteriaGroupTitle = styled.div`
    font-family: 'DIN Next W01 Medium';
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    color: #157be7;
`;

export const CriteriaItem = styled.div`
    font-size: 12px;
    line-height: 14px;
    color: ${blueDark01};
    font-family: 'Proxima Nova';
`;

export const CriteriaItemLabel = styled.span`
    font-family: 'Proxima N W15 Bold';
`;

export const CriteriaEmpty = styled.div`
    padding-left: 50px;
    font-size: 12px;
    color: ${blueDark01};
`;
